<template>
	<div class="flex-sub flex flex-direction align-center">
		<!-- <div class="image flex justify-center"><img :src="article.image" alt="" /></div> -->
		<div class="images">
			<img v-for="(item, index) in article.images" :key="index" :src="item" alt="">
		</div>
		<div class="content flex-sub rich-text" v-html="article.content"></div>
	</div>
</template>

<script>
export default {
	props:{
		article: Object
	},
	data() {
		return {};
	},
	methods: {

	}
};
</script>

<style lang="scss" scoped>
	.image{
		img{
			width: 6.5rem;
			height: auto;
			margin-bottom: 0.2rem;
		}
	}
	.images{
		img{
			width: 6.5rem;
			height: auto;
			margin: 0 auto .2rem;
			display: block;
		}
	}
	.content{
		padding: 0.1rem 0.25rem;
		
	}
</style>
